import { useState } from "react"
import { Box, Button, ButtonGroup, Typography } from "@mui/material"
import Grid2 from "@mui/material/Unstable_Grid2"
import { useMediaQuery } from '@mui/material'
import PriceCard from "../../../../components/common/pricing/PriceCard"
import { PLAN_LIST } from "../../../../components/common/pricing/plans"


const styles = {
    container: (isMobile) => ({
        m: isMobile ? '1.2rem .8rem' : '4rem 14vw',
        p: isMobile ? '2rem 1.2rem' : '3rem 6vw',
        fontFamily: 'Catamaran',
    }),
    header: {
        color: 'primary.black',
        fontFamily: 'inherit',
        fontWeight: 900,
        textAlign: 'center',
        m: '0 0 1rem 0',
    },
    subHeader: {
        color: 'text.gray',
        fontFamily: 'inherit',
        fontWeight: 500,
        textAlign: 'center',
        m: '0 0 1rem 0',
    },
    buttonGroup: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: '2rem'
    },
    button: {
        fontFamily: 'inherit',
        textTransform: 'none',
        borderRadius: '30px',
        p: '.2rem 1.2rem',
    },
}

export default function PricingSection() {
    const isMobile = useMediaQuery('(max-width:950px)')
    const [showAnnualPrice, setShowAnnualPrice] = useState(false)

    const togglePriceSettings = () => {
        setShowAnnualPrice(!showAnnualPrice)
    }

    const tiers = PLAN_LIST

    return (
        <Box id="pricing" sx={styles.container(isMobile)}>
            <section>
                <Typography
                    variant={isMobile ? 'h4' : 'h3'}
                    component="h3"
                    sx={styles.header}>
                    Powerful features, simple pricing
                </Typography>
            </section>
            <section style={styles.buttonGroup}>
                <ButtonGroup aria-label="Vibio pricing switch">
                    <Button
                        variant={showAnnualPrice ? 'outlined' : 'contained'}
                        onClick={() => togglePriceSettings()}
                        sx={styles.button}
                    >
                        Monthly
                    </Button>
                    <Button
                        variant={showAnnualPrice ? 'contained' : 'outlined'}
                        onClick={() => togglePriceSettings()}
                        sx={styles.button}
                    >
                        Yearly
                    </Button>
                </ButtonGroup>
                <Typography
                    variant="body2"
                    component="p"
                    sx={{
                        fontFamily: 'inherit',
                        fontWeight: 500,
                        color: 'text.gray',
                        textAlign: 'center',
                        mt: 1,
                        fontSize: '0.9rem',
                    }}
                >
                    Get 2 months free on yearly plan. Cancel anytime.
                </Typography>
            </section>
            <Grid2 container spacing={4} justifyContent="center">
                {/* {tiers.map(tier => */}
                <PriceCard
                    key={tiers[1].name}
                    tier={tiers[1]}
                    isAnnual={showAnnualPrice}
                    buttonAction="/signup"
                    compact={0.85}
                />
                {/* )} */}
            </Grid2>
        </Box>
    )
}
